import React from 'react';
import { Box, CircularProgress, Alert, Typography } from '@mui/material';
import { useSaleFulfillmentDetail } from '../../../../hooks/useSaleFulfillmentDetail';
import { SaleFulfillmentTimeline } from '../SaleFulfillment/SaleFulfillmentTimeline';

interface OrdersTableExpandedRowProps {
  orderId: number;
}

/** Compact SOL/TRL logistics when a mixed-sale order row is expanded. */
export const OrdersTableExpandedRow: React.FC<OrdersTableExpandedRowProps> = ({ orderId }) => {
  const { detail, isLoading, error } = useSaleFulfillmentDetail(orderId);

  if (isLoading) {
    return (
      <Box sx={{ py: 1.5, px: 2, bgcolor: 'background.paper' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            Cargando información de logística…
          </Typography>
        </Box>
      </Box>
    );
  }

  // Prefer last good snapshot when a background refresh fails.
  if (detail != null) {
    return (
      <Box sx={{ py: 1.5, px: 2, bgcolor: 'background.paper' }}>
        {error != null && (
          <Alert severity="warning" sx={{ py: 0, mb: 1 }}>
            No se pudo actualizar la logística. Se muestra la última información disponible.
          </Alert>
        )}
        <SaleFulfillmentTimeline groups={detail.groups ?? []} dense />
      </Box>
    );
  }

  if (error != null) {
    return (
      <Box sx={{ py: 1.5, px: 2, bgcolor: 'background.paper' }}>
        <Alert severity="error" sx={{ py: 0 }}>
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 1.5, px: 2, bgcolor: 'background.paper' }}>
      <SaleFulfillmentTimeline groups={[]} dense />
    </Box>
  );
};

export default OrdersTableExpandedRow;
